<template>
    <div class="template-picker">
        <div ref="scrollingbox">
            <div v-show="isGeneralLoad"
                 class="section is-full has-text-centered">
                <font-awesome-icon icon="redo-alt"
                                   class="search-spinner fa-spin" />
            </div>
            <template-categories v-show="!previewMode && !isGeneralLoad"
                                 :categories="siteplusCategories"
                                 :selected-category="selectedCategory"
                                 @selectcategory="selectCategory" />

            <!-- IMAGES  -->
            <template-listing v-show="!previewMode && !isGeneralLoad"
                              :templates="templates.templates"
                              @preview="preview" />

            <template-preview v-show="previewMode && !isGeneralLoad"
                              :template="selectedTemplate"
                              @close-preview="closePreview" />
        </div>
    </div>
    
</template>

<script>

import templatePickerMixin from '../mixins/template-picker'
import templateCategories from '../components/TemplatePicker/TemplateCategories'
import templateListing from '../components/TemplatePicker/TemplateListing'
import templatePreview from '../components/TemplatePicker/TemplatePreview'

export default {

  name: 'TemplatePicker',

  components: {
    templateListing,
    templatePreview,
    templateCategories
  },

  mixins: [
    templatePickerMixin
  ],

  data () {
    return {
      selectedCategory: 'all',
      templates: [],
      pages: [],
      previewMode: false,
      selectedTemplate: {},
      isGeneralLoad: true,
      currentPage: 1
    }
  },

  watch: {
    siteplusCategories () {
      if (this.siteplusCategories.length > 0) {
        this.selectedCategory = this.siteplusCategories[0]
        this.getTemplates()
      }
    },

    selectedCategory () {
      this.getTemplates()
    },

    templates () {
      if (this.siteplusCategories.length > 0 && this.templates.templates !== 'undefined') {
        this.isGeneralLoad = false
      }
    }
  },

  mounted () {
    this.$nextTick(function () {
      window.addEventListener('scroll', this.onScroll)
    })
  },

  beforeDestroy () {
    window.removeEventListener('scroll', this.onScroll)
  },

  methods: {
    preview (index) {
      this.selectedTemplate = this.templates.templates[index]
      this.previewMode = true
    },

    closePreview () {
      this.previewMode = false
      this.selectedTemplate = {}
    },

    selectCategory (category) {
      if (category !== this.selectedCategory) {
        this.selectedCategory = category
        this.currentPage = 1
      }
    },

    async getTemplates () {
        this.templates = await this.getSiteplusTemplates(this.selectedCategory, this.currentPage)
    },

    onScroll () {
      var box = this.$refs.scrollingbox

      if (box) {
        var marginTop = box.getBoundingClientRect().top
        var innerHeight = window.innerHeight
          innerHeight = innerHeight / 2
        if ((innerHeight + marginTop) < 1100) {
            this.pageLoader()
        }
      }
    },
    
    async pageLoader () {
     
      if (typeof (this.templates.pages) !== 'undefined' && this.currentPage < this.templates.pages) {
        this.currentPage++
        var newTemplates = await this.getSiteplusTemplates(this.selectedCategory, this.currentPage);

        if (typeof (newTemplates.templates) !== 'undefined') {          
          for (var index in newTemplates.templates) {        
            var found = false;
            var listIndex = this.templates.templates.length-1;

            while (!found  && listIndex >=0 ) {
              if (this.templates.templates[listIndex].imageUrl === newTemplates.templates[index].imageUrl) {
                found = true;
              }
              listIndex= listIndex-1;
            }

            if (!found ) {
              this.templates.templates.push(newTemplates.templates[index]);
            }       
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" >
@import '../../sass/_variables.scss';

  .template_image {
    cursor: pointer;
  }

  .main-section {
    background-color: #ecf0f1;
  }

  .search-spinner {
    font-size: 136px;
    color: var(--primary-color);
    margin-top: 30px;
  }

  @media only screen and (max-width: $break-small) {
    .time-picker-group {
      flex-direction: column;
      > div:first-child {
        align-self: baseline;
        margin: 5px 0;
      }
    }
  }
</style>

<style type="text/css">

  .shake {
    animation-duration: .4s;
    animation-iteration-count: 1;
    animation-name: shake !important;
    animation-timing-function: linear;
    transform-origin: 50% 50%;
  }
</style>
